/* unplugin-vue-components disabled */import { render } from "./details_m.vue?vue&type=template&id=3f124de0&scoped=true"
import script from "./details_m.vue?vue&type=script&lang=js"
export * from "./details_m.vue?vue&type=script&lang=js"

import "./details_m.vue?vue&type=style&index=0&id=3f124de0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f124de0"]])

export default __exports__